import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import BiButton from '@wix/da-bi/pkg/Components/BiButton';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import EllipsisIcon from '@wix/da-ds/pkg/Icons/Ellipsis';
import MoreMenuContent from './MoreMenuContent';
import ActionBarIcon from '../../_partials/ActionBarIcon';
import ActionBarItemWrapper from '../../_partials/items/ActionBarItemWrapper';
import ActionBarToggleButton from '../../_partials/items/ActionBarToggleButton';
import MoreMenuMobileDropdown from './MoreMenuMobileDropdown';
import { getDeviationResourceType } from '../../../DeviationViews/_helpers';
import { useActionsWithPopups } from './hooks';
import s from './MoreButton.scss';
import { BiData } from '@wix/da-bi/pkg/events';
export const MoreButton = ({ deviation })=>{
    const { t } = useTranslation();
    const isMobile = useContext(MobileContext);
    const actionsWithPopups = useActionsWithPopups(deviation);
    if (isMobile) {
        return /*#__PURE__*/ React.createElement(BiButton, {
            className: s['mobile-button']
        }, /*#__PURE__*/ React.createElement(ActionBarIcon, {
            icon: EllipsisIcon
        }), /*#__PURE__*/ React.createElement(MoreMenuMobileDropdown, {
            deviation: deviation,
            actionsWithPopovers: actionsWithPopups
        }));
    }
    return /*#__PURE__*/ React.createElement(React.Fragment, null, Object.values(actionsWithPopups).map((popupAction)=>popupAction && popupAction.popup), /*#__PURE__*/ React.createElement(ActionBarItemWrapper, {
        allowMobilePopover: true,
        placement: isMobile ? 'top-end' : undefined,
        renderPopover: ({ closeTooltip })=>/*#__PURE__*/ React.createElement(MoreMenuContent, {
                deviation: deviation,
                closeTooltip: closeTooltip,
                actionsWithPopups: actionsWithPopups
            }),
        notificationTypes: Object.values(actionsWithPopups).map((actionWithPopup)=>actionWithPopup === null || actionWithPopup === void 0 ? void 0 : actionWithPopup.notificationType).filter((notificationType)=>notificationType !== undefined),
        tooltip: t('actionbar.more.tooltip'),
        openBiData: BiData({
            evid: 417,
            typeid: getDeviationResourceType(deviation),
            itemid: deviation.deviationId,
            sectionname: 'deviation'
        })
    }, /*#__PURE__*/ React.createElement(ActionBarToggleButton, {
        icon: EllipsisIcon
    })));
};
MoreButton.displayName = 'MoreButton';
export default MoreButton;
